import classnames from "classnames";
import React from "react";

import Tick, { tickSizes } from "features/common/components/Tick";
import LoadingSpinner from "features/common/spinners/LoadingSpinner";

import "./LoadingTick.scss";

type Props = {
  checked?: boolean;
  className?: string;
  loadingColour?: "white" | "dark";
  tickColor?: string;
  loading?: boolean;
};

const LoadingTick = ({
  checked,
  loading,
  className,
  loadingColour = "dark",
  tickColor
}: Props) => {
  return (
    <div className={classnames("LoadingTick", className)}>
      {loading ? (
        <LoadingSpinner colour={loadingColour} loading={loading} />
      ) : (
        <Tick
          animate
          checked={checked && !loading}
          color={tickColor}
          size={tickSizes.MEDIUM}
        />
      )}
    </div>
  );
};

export default LoadingTick;
